import { Injectable, Inject } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs/Rx';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { Http } from '@angular/http';
import { GridRequestParams } from '../shared/_models/GridRequestParams';
import { AllUsers } from './_models/Users';
import { UsersService } from './_services/users.service';
import { BaseEndpoint } from '../app.constants';

@Injectable()

export class UsersGridService extends BehaviorSubject<GridDataResult> {
    totalRecords: number;
    gridData: Array<any>;
    gridDataList: any[];
    exportCsvData: any[];
    errorCode: number;
    usersDetails: Array<AllUsers[]>;
    constructor(private usersService: UsersService,
        private http: Http,
        @Inject(BaseEndpoint) private baseApiEndpoint
    ) {
        super(null);
    }

    public query(searchOptions: GridRequestParams, useForCsv: boolean): Observable<boolean> {
        return this.getAllUsersData(searchOptions, useForCsv).map(x => {
            super.next(x);
            return true;
        });
    }

    getAllUsersData(filter: any, useForCsv = false): Observable<GridDataResult> {
        this.errorCode = 0;
        const tempFilter = JSON.parse(JSON.stringify(filter));
        if (useForCsv) {
            tempFilter.paginationStartIndex = 0;
            tempFilter.pageSize = this.totalRecords;
        }
        if (tempFilter.searchTerm === '') {
            tempFilter.searchTerm = undefined;
        }
        const url = this.baseApiEndpoint + '/getallusers';
        return this.http.get(this.usersService.getSearchUrl(url, tempFilter)).map(response => {
            const apiResponse: GridRequestParams = response.json();
            return apiResponse;
        }).catch(err => {
            this.totalRecords = 0;
            const errorSiteResponse: GridRequestParams = {
                pageSize: 0,
                paginationStartIndex: 0,
                searchBy: '',
                sortBy: {sortOrder: 0, sortColumn: ''},
                status: err.status
            };
            return Observable.of(errorSiteResponse);
        }).map(response => {
            // tslint:disable-next-line: radix
            this.errorCode = parseInt(response.status);
            const usersData = response['result'];
            this.totalRecords = usersData === null ? 0 : usersData.totalRecords;
            this.usersDetails = usersData === null ? [] : usersData.userDetails;
            if (!useForCsv) {
                this.gridDataList = new Array<any>();
            } else {
                this.exportCsvData = new Array<any>();
            }
            if (!useForCsv) {
                this.gridDataList = this.usersDetails;
            } else {
                this.exportCsvData = this.usersDetails;
            }
            return {
                data: !useForCsv ? this.gridDataList : this.exportCsvData,
                total: this.totalRecords
            };
        });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/users/users-grid.service.ts